import "./SideNav.css";

import ComicList from "../ComicList";
import {Link} from "react-router-dom";
import navBurk from "../images/nav/burk.png";
import navComic from "../images/nav/comic.png";
import navContact from "../images/nav/contact.png";
import navDiscord from "../images/nav/discord.png";
import navFaq from "../images/nav/faq.png";
import navHeld from "../images/nav/held.png";
import navLatest from "../images/nav/latest.png";
import navNews from "../images/nav/news.png";
import navNoah from "../images/nav/noah.png";
import navPatreon from "../images/nav/patreon.png";
import navTobi from "../images/nav/tobi.png";
import navTop from "../images/nav/nav_top.png";
import {useSelector} from "react-redux";

function SideNav() {
  const stories = useSelector(state => state.stories);
  const comicList = new ComicList(stories.comics['hoh']);
  const first = comicList.firstComic();
  const firstBurk = comicList.firstComic('Burk');
  const firstNoah = comicList.firstComic('Noah');
  const firstTobi = comicList.firstComic('Tobi');
  const firstHeld = comicList.firstComic('Held');

  return (
    <div id="nav">
      <div id="nav_top"><img src={navTop} alt="" /></div>
      <ul>
        <li><Link to={"/"}><img src={navNews} alt="News" /></Link></li>
        <li><Link to={`/hoh/${first}`}><img src={navComic} alt="Full Story" /></Link></li>
        <li>
          <Link to={"/hoh/latest"}><img src={navLatest} alt="Latest Comic" /></Link>
        </li>
        <li><Link to={`/hoh/burk/${firstBurk}`}><img src={navBurk} alt="Burk&apos;s Story" /></Link></li>
        <li><Link to={`/hoh/noah/${firstNoah}`}><img src={navNoah} alt="Noah&apos;s Story" /></Link></li>
        <li><Link to={`/hoh/tobi/${firstTobi}`}><img src={navTobi} alt="Tobi&apos;s Story" /></Link></li>
        <li><Link to={`/hoh/held/${firstHeld}`}><img src={navHeld} alt="Held&apos;s Story" /></Link></li>
        <li><Link to={"/contact"}><img src={navContact} alt="Contact" /></Link></li>
        <li><a href="https://discord.gg/rpAAYbP"><img src={navDiscord} alt="Discord Chat" /></a></li>
        <li><Link to={"/faq"}><img src={navFaq} alt="FAQ" /></Link></li>
        <li>
          <a href="http://www.patreon.com/neoriceisgood">
            <img src={navPatreon} alt="Patreon Support" />
          </a>
        </li>
      </ul>

      <div id="twc_container">
        <a href='https://www.topwebcomics.com/vote/9020/default.aspx'
            title='Vote for Hero Oh Hero on TopWebComics!'>
          <img src='https://www.topwebcomics.com/rankimages/rankimage.aspx?ImageTemplate=dynamiclink2&SiteID=9020'
                alt='Top Web Comics Vote' />
        </a>
      </div>
    </div>
  );
}

export default SideNav;